export const EVENT_SUBSCRIPTIONS_RESET_STATE = 'EVENT_SUBSCRIPTIONS_RESET_STATE';
export const EVENT_SUBSCRIPTIONS_CURRENT_ITEM = 'EVENT_SUBSCRIPTIONS_CURRENT_ITEM';

export const EVENT_SUBSCRIPTIONS_REQUEST_LOADING = 'EVENT_SUBSCRIPTIONS_REQUEST_LOADING';
export const EVENT_SUBSCRIPTIONS_REQUEST_SUCCESS = 'EVENT_SUBSCRIPTIONS_REQUEST_SUCCESS';
export const EVENT_SUBSCRIPTIONS_REQUEST_FAILED = 'EVENT_SUBSCRIPTIONS_REQUEST_FAILED';

export const EVENT_SUBSCRIPTIONS_CURRENT_ACTION = 'EVENT_SUBSCRIPTIONS_CURRENT_ACTION';
export const EVENT_SUBSCRIPTIONS_RESET_ACTION = 'EVENT_SUBSCRIPTIONS_RESET_ACTION';